import { get } from '../../services/api';
import { mentionableUsersEndpoint } from '../../services/endpoint';
import { config } from '../../components/CommentInput/MentioningMenuUtilities';
import { isMention } from './mentionFormatters';

export const requestMentionableUsers = async (params) => {
  try {
    const res = await get(mentionableUsersEndpoint(), {
      params
    });

    return res;
  } catch (err) {
    // TODO: Determine error handling strategy
    // Returning an empty items array
    // will ensure the list doesn't appear
    return {
      items: []
    };
  }
};

export const generateSearchParameters = ({
  communityId,
  communityType,
  isMultipleCommunityPosting
}) => {
  const params = config
    .find(({ communityTypes }) => communityTypes.includes(communityType))
    .generateParams(communityId, isMultipleCommunityPosting);

  return {
    ...params,
    all: true
  };
};

export const extractTextByCommunity = async (splitText, communityPostId) => {
  const comment = [];

  // eslint-disable-next-line array-callback-return,consistent-return
  const promise = splitText.map((text, index) => {
    if (isMention(text)) {
      const user = text.match(new RegExp('{@\\|\\d+\\|user}', 'g'));
      if (user) {
        const userBlock = user[0].match(/[0-9]+/);
        const userId = userBlock[0];

        const userNameBlock = text.split(
          new RegExp('{@\\|\\d+\\|user}\\[<(.+?)>\\]', 'g')
        );
        const userName = userNameBlock && userNameBlock[1];

        return requestMentionableUsers({
          community_id: communityPostId,
          query: userName
        }).then((res) => {
          if (Array.isArray(res.items) && res.items.length > 0) {
            const result = res.items.filter((u) => {
              return parseInt(userId, 10) === u.id;
            });
            if (Array.isArray(result) && result.length > 0) {
              comment.splice(index, 0, text);
            }
          }
        });
      }
    } else {
      comment.push(text);
    }
  });
  // resolve all promises at once is more efficient
  await Promise.all(promise);
  return comment;
};

export default requestMentionableUsers;
